import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import SleepUsersTable from '../../../SleepHub/SleepUsersTable';
import { SidebarContext } from '../../../../context/SidebarContext';
import { getLocalStorageItem } from '../../../../utils/helper';
import { fetchCompanySleepUsers } from './companySleepApi';

/**
 * Company Sleep → Employees/Members list.
 * Every user of the current population appears (never-logged ones with
 * dashes, sorted last); a row opens their sleep profile.
 */
const CSleepUsers = () => {
  const navigate = useNavigate();
  const { isB2BFansMode } = useContext(SidebarContext);
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  const fetcher = useCallback(
    (params) => fetchCompanySleepUsers(params),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Sleep — {isB2BFansMode ? 'Members' : 'Employees'} | Shoorah</title>
      </Helmet>

      <p className="text-sm text-gray-500 dark:text-gray-400 mb-3">
        Your {isB2BFansMode ? 'members' : 'employees'} and their sleep activity. Open a user to
        see their full sleep profile.
      </p>

      <SleepUsersTable
        fetcher={fetcher}
        showCompanyColumn={false}
        onOpenUser={(rowData) => navigate(`/${slug}/sleep/user?userId=${rowData?._id}`)}
        tableName="company_sleep_users"
      />
    </div>
  );
};

export default CSleepUsers;
